"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const LoadingSpinner_1 = __importStar(require("../../common/js/components/LoadingSpinner"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const TypeaheadInput_1 = __importDefault(require("../atoms/TypeaheadInput"));
const DelegationStore_1 = __importDefault(require("../stores/DelegationStore"));
const ProfileStore_1 = __importDefault(require("../stores/ProfileStore"));
class ChangeCompanyProfileModal extends react_1.default.Component {
    selectedCompanyId = null;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            selectedCompanyId: mobx_1.observable,
            isLoading: mobx_1.computed,
        });
    }
    get isLoading() {
        return ProfileStore_1.default.isLoading || DelegationStore_1.default.isLoading;
    }
    componentDidMount() {
        ProfileStore_1.default.loadOnBehalfOfCustomers();
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "modal-header znd-modal__header" },
                react_1.default.createElement("h3", { className: "znd-modal__title" }, (0, translation_1.t)('change_company_profile_modal.title')),
                react_1.default.createElement("div", { className: "znd-modal__close", onClick: this.props.onCancel },
                    react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
            react_1.default.createElement("div", { className: "modal-body znd-modal__body znd-change-company-profile-modal__body pb-0" },
                react_1.default.createElement("div", { className: "znd-change-company-profile-modal__info-container" },
                    react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.info, className: 'znd-change-company-profile-modal__info-icon' }),
                    react_1.default.createElement("p", { className: 'znd-change-company-profile-modal__info-text mb-0' }, (0, translation_1.t)('change_company_profile_modal.info_text'))),
                react_1.default.createElement("div", { className: "w-100 position-relative" },
                    react_1.default.createElement(TypeaheadInput_1.default, { options: ProfileStore_1.default.customerOptions, value: this.selectedCompanyId ?? '', placeholder: (0, translation_1.t)('change_company_profile_modal.select_company.placeholder'), onChange: (0, mobx_1.action)((value) => {
                            this.selectedCompanyId = value;
                        }) }),
                    this.isLoading ? react_1.default.createElement(LoadingSpinner_1.default, { center: true, style: LoadingSpinner_1.LoadingSpinnerStyle.small }) : null)),
            react_1.default.createElement("div", { className: "modal-footer znd-modal__footer znd-change-company-profile-modal__footer" },
                react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('message_modal.cancel'), onClick: this.props.onCancel }),
                react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('change_company_profile_modal.submit'), loading: DelegationStore_1.default.isLoading, disabled: (this.selectedCompanyId ?? null) === null || this.isLoading, onClick: () => {
                        DelegationStore_1.default.updateDelegationAndRefreshToken(this.selectedCompanyId ?? '').finally(this.props.onDone);
                    } }))));
    }
}
exports.default = (0, mobx_react_1.observer)(ChangeCompanyProfileModal);
